module.exports = __webpack_public_path__ + "static/media/upload_icon.1b55a953.png";